import Actions from '../../odata/actions';

const actions = new Actions('currency', 'currencies');

export default actions;
